export default __webpack_public_path__ + "static/media/img--interiors-7.ac78e2e9.jpg";